import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3fb2f3af")
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "d-flex justify-space-between pa-2 align-center" }
const _hoisted_3 = {
  key: 0,
  class: "mb-2 expansion-content pa-2"
}
const _hoisted_4 = { class: "justify-end d-flex width-full" }
_popScopeId()

import { withDefaults, ref } from 'vue'
import { readableConditionOperators } from '@/lib/helper'
import { IConditionField } from '@/interfaces/hoppermation'

interface IProps {
  removeItem?: (index: number) => void
  conditionFields: IConditionField[]
  items?: []
}


export default /*#__PURE__*/_defineComponent({
  props: {
    removeItem: { type: Function, required: false, default: () => ({}) },
    conditionFields: { type: Array, required: true },
    items: { type: Array, required: false, default: () => [] }
  },
  setup(__props: any) {

const props = __props as { removeItem: (index: number) => void, conditionFields: IConditionField[], items: [] }


const openPanelId = ref(-1)

const togglePanel = (index: number): void => {
  openPanelId.value = openPanelId.value === index ? -1 : index
}

const isOpen = (index: number): boolean => {
  return openPanelId.value === index
}

const getReadableFieldLabel = (fieldName: string): string => {
  return props.conditionFields.find((condition) => condition.field === fieldName)?.fieldLabel || ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["my-2 expansion-panel card", isOpen(index) ? 'open' : '']),
        onClick: ($event: any) => (togglePanel(index))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('details.condition.title')) + " " + _toDisplayString(index + 1), 1),
          _createVNode(_component_v_icon, { class: "activator" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isOpen(index) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        (isOpen(index))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('details.condition.conditions.desc3')) + " " + _toDisplayString(getReadableFieldLabel(item.field)) + " " + _toDisplayString(_ctx.$t(_unref(readableConditionOperators)(item.operator))) + " " + _toDisplayString(item.value), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  small: "",
                  onClick: () => props.removeItem(index)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('actions.delete')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    }), 128))
  ]))
}
}

})